// extracted by mini-css-extract-plugin
export default {"card":"SkipForm-styles-module--card--L4VqD"};